import {
  Button,
  Checkbox,
  Chip,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useStyles from "../MasterData.css";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import translation from "../../../i18n/i18.json";
import SearchIcon from "@material-ui/icons/Search";
import { UserFilter } from "../../../models/Master/UserFilter";
import { User } from "../../../models/Master/User";
import CancelIcon from "@material-ui/icons/Cancel";
import { SBU } from "../../../models/SBU";

import {
  InforDisplyaDuration,
  MasterDataConstants,
} from "../../../constants/AppConstants";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import { MasterDataService } from "../../../services/MasterDataService";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import UserAddDialog from "./UserAddDialog";
import { UserListRespone } from "../../../models/Master/UserListRespone";
import { UserRole } from "../../../models/UserRole";
import { Cluster } from "../../../models/Cluster";
import { Company } from "../../../models/Company";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { RMCategory } from "../../../models/RMCategory";
import {ProcurementCategory } from "../../../models/ProcurementCategory";
import {ProcurementSubCategory } from "../../../models/ProcurementSubCategory";

export default function UserManagement() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const initialState: User = {
    id: 0,
    userName: "",
    userCompanies: [],
    //userRoles: [],
    isActive: true,
    emailAddress: "",
    userClusters: [],
  };

  const rowsPerPage = MasterDataConstants.TablerowCount;
  const [page, setPage] = React.useState(0);
  const [rowCount, setRowCount] = React.useState(0);
  const [isTableLoading, setIsTableLoading] = React.useState(false);
  const [filterParams, setFilterParams] = useState<UserFilter>({
    pageNo: 0,
    pageSize: rowsPerPage,
    emailAddress: "",
    // userName: "",
    // sbuCodes: [],
    // userRoles: [],
    // nameOrder:"asc",
    isActive: true,
  });
  // const [sbuList, setSbuList] = useState<SBU[]>([]);
  // const [userRolesList, setUserRolesList] = useState<UserRole[]>([]);

  const [selectedData, setSelectedData] = useState<User>(initialState);
  const [tableRowData, setTableRowData] = useState<User[]>([]);

  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  // const addpopupMasterDataCount = 3;
  //const [addpopupMasterDataCounter, setAddpopupMasterDataCounter] = useState(0);
  const [isEditPress, setIsEditPress] = useState(false);

  const [sbuList, setSbuList] = useState<Company[]>([]);
  const [userRolesList, setUserRolesList] = useState<UserRole[]>([]);
  const [clustersList, setClustersList] = useState<Cluster[]>([]);
  const [userRmCategoryList, setRmCategoryList] = useState<RMCategory[]>([]);
  const [userProcurementCategoryList, setProcurementCategoryList] = useState<ProcurementCategory[]>([]);
  const [userProcurementSubCategoryList, setProcurementSubCategoryList] = useState<ProcurementSubCategory[]>([]);
  const nameOrderList = [
    { code: "ASC", name: "Ascending" },
    { code: "DSC", name: "Descending" },
  ];

  const tableColumnData = [
    { name: translation.master_user_name },
    { name: translation.master_email },
    { name: translation.master_user_company },
    // { name: translation.master_userole },
    { name: translation.master_usercluster },
    { name: translation.master_user_isactive },
  ];

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  const handleAddTableData = (e: any) => {
    setSelectedData(initialState);
    //setIsUpdateOpen(true);
    getMaterDataAdd();
  };

  const handleChange = (input: string) => (e: any) => {
    let val: any = e.target.value;
    if (e.target.type === "checkbox") {
      setFilterParams({ ...filterParams!, [input]: e.target.checked });
    }
    // else if(input === "sbuCodes" || input === "userRoles" ){
    //   setFilterParams({...filterParams!, [input]: e.target.value as string[]});
    // }
    else {
      setFilterParams({ ...filterParams!, [input]: val });
    }
  };

  // const handleDelete = (e: React.MouseEvent, value: string, input: string) => {

  //   e.preventDefault();
  //   if (input === "sbuCodes") {
  //     setFilterParams({
  //           ...filterParams,
  //           [input]:filterParams.sbuCodes.filter((code) => {
  //               return (code !== value);
  //             })
  //         });
  //   } else if (input === "userRoles") {
  //     setFilterParams({
  //           ...filterParams,
  //           [input]:filterParams.userRoles.filter((code) => {
  //               return (code !== value);
  //             })
  //         });
  //   }
  // };
  const copyUser = (user: User) => {
    var copyUser: User = {
      id : user.id,
      userName: user.userName,
      emailAddress : user.emailAddress,
      isActive : user.isActive,
      userClusters: user.userClusters 
      ? user.userClusters.map((cl) => { 
        return { 
          id: cl.id, 
          clusterId: cl.clusterId, 
          clusterName : cl.clusterName, 
          roleIds : cl.roleIds ? [...cl.roleIds] : [], 
          approvalPointIds: cl.approvalPointIds ? [...cl.approvalPointIds] : [] ,
          rmCategoryIds : cl.rmCategoryIds ? [...cl.rmCategoryIds] : [], 
          procurementCategoryIds : cl.procurementCategoryIds ? [...cl.procurementCategoryIds] : [], 
           procurementSubCategoryIds : cl.procurementSubCategoryIds ? [...cl.procurementSubCategoryIds] : [], 
        }
      })
      : [],
      userCompanies: user.userCompanies 
      ? user.userCompanies.map((co) => { 
        return { 
          id: co.id, 
          companyCode: co.companyCode, 
          roleIds : co.roleIds ? [...co.roleIds] : [], 
          approvalPointIds: co.approvalPointIds ? [...co.approvalPointIds] : [] ,
          rmCategoryIds : co.rmCategoryIds ? [...co.rmCategoryIds] : [], 
          procurementCategoryIds : co.procurementCategoryIds ? [...co.procurementCategoryIds] : [], 
          procurementSubCategoryIds : co.procurementSubCategoryIds ? [...co.procurementSubCategoryIds] : [], 
        }

      })
      : []
    }; 
    return copyUser;
  };

  const handleFilter = (e: any) => {
    setFilterParams({ ...filterParams, pageNo: 1 });
    setPage(0);
    setIsTableLoading(true);
  };

  const handleChangePage = (event: any, newPage: number) => {
    setFilterParams({ ...filterParams, pageNo: newPage + 1 });
    setPage(newPage);
    setIsTableLoading(true);
  };

  const getDisplaySBU = (row: User) => {
    if (row.userCompanies && row.userCompanies.length > 0) {
      let sbustring = row.userCompanies.map(c => {
          return c.companyCode
        }).join(", ");
      return sbustring;
    }
    return "";
  };

  // const getDisplayRoles = (row: User) => {
  //   if (row.userRoles && row.userRoles.length > 0) {
  //     let rolenames = row.userRoles.map((role: UserRole, index) => {
  //       return role.roleName;
  //     });
  //     if (rolenames && rolenames.length > 0) {
  //       let rolesstring = rolenames.join(", ");
  //       return rolesstring;
  //     }
  //     return "";
  //   }
  //   return "";
  // };

  const getDisplayClusters = (row: User) => {
    if (row.userClusters && row.userClusters.length > 0) {
      let clusternames = row.userClusters.map((cluster: Cluster, index) => {
        return cluster.clusterName;
      });
      if (clusternames && clusternames.length > 0) {
        let clustersstring = clusternames.join(", ");
        return clustersstring;
      }
      return "";
    }
    return "";
  };

  // useEffect(() => {
  //   if (addpopupMasterDataCounter !== 0) {
  //     if (addpopupMasterDataCounter <= addpopupMasterDataCount) {
  //       setAddpopupMasterDataCounter(addpopupMasterDataCounter + 1);
  //       if (addpopupMasterDataCounter === addpopupMasterDataCount) {
  //         setAddpopupMasterDataCounter(0);
  //         //setIsEditPress(false);
  //         compeleteRequest(true);
  //         setIsUpdateOpen(true);
  //       }
  //       //return;
  //     }
  //   }
  // }, [addpopupMasterDataCounter]);

  // const updateAddMasterDataCount = () => {
  //   // setAddpopupMasterDataCounter((state) => {
  //   //   return addpopupMasterDataCounter + 1;
  //   // });
  //   setAddpopupMasterDataCounter(addpopupMasterDataCounter + 1);
  // };

  // useEffect(() => {
  //   if(isEditPress){
  //     prepareForRequest();
  //     MasterMetaDataService.getSBUCodes(
  //       function (sbuList: Array<SBU>) {
  //         setSbuList(sbuList);
  //         updateAddMasterDataCount();
  //         //compeleteRequest(true);
  //       },
  //       function (error: Error) {
  //         setSbuList([]);
  //         updateAddMasterDataCount();
  //         //compeleteRequest(false);
  //       }
  //     );

  //     MasterMetaDataService.getUserRoles(
  //       function (userRolesist: Array<UserRole>) {
  //         setUserRolesList(userRolesist);
  //         updateAddMasterDataCount();
  //         //compeleteRequest(true);
  //       },
  //       function (error: Error) {
  //         setUserRolesList([]);
  //         updateAddMasterDataCount();
  //         //compeleteRequest(false);
  //       }
  //     );

  //     // MasterMetaDataService.getClusters(
  //     //   function (clustersList: Array<Cluster>) {
  //     //     setClustersList(clustersList);
  //     //     //updateAddMasterDataCount();
  //     //     //compeleteRequest(true);
  //     //   },
  //     //   function (error: Error) {
  //     //     setClustersList([]);
  //     //    // updateAddMasterDataCount();
  //     //     //compeleteRequest(false);
  //     //   }
  //     // );
  //   }

  //   // return () => {

  //   // }

  // }, [isEditPress])

  const getMaterDataAdd = () => {
    prepareForRequest();

    Promise.allSettled([
      VendorMasterData.getCompanyCodes(
        function (sbuList: Array<Company>) {
          setSbuList(sbuList);
          //updateAddMasterDataCount();
          //compeleteRequest(true);
        },
        function (error: Error) {
          setSbuList([]);
          //updateAddMasterDataCount();
          //compeleteRequest(false);
        }
      ),
      MasterMetaDataService.getUserRoles(
        function (userRolesist: Array<UserRole>) {
          setUserRolesList(userRolesist);
          //updateAddMasterDataCount();
          //compeleteRequest(true);
        },
        function (error: Error) {
          setUserRolesList([]);
          //updateAddMasterDataCount();
          //compeleteRequest(false);
        }
      ),
      MasterMetaDataService.getClusters(
        function (clustersList: Array<Cluster>) {
          setClustersList(clustersList);
          //updateAddMasterDataCount();
          //compeleteRequest(true);
        },
        function (error: Error) {
          setClustersList([]);
          //updateAddMasterDataCount();
          //compeleteRequest(false);
        }
      ),
      MasterMetaDataService.getRMCategories(
        function (userRmCategoryList: Array<RMCategory>) {
          setRmCategoryList(userRmCategoryList);          
        },
        function (error: Error) {
          setRmCategoryList([]);
        }
      ),
      MasterMetaDataService.getProcurementCategories(
        function (userProcurementCategoryList: Array<ProcurementCategory>) {
          setProcurementCategoryList(userProcurementCategoryList);          
        },
        function (error: Error) {
          setProcurementCategoryList([]);
        }
      ),
      MasterDataService.getProcurementSubCategories(
        function (userProcurementSubCategoryList: Array<ProcurementSubCategory>) {
          setProcurementSubCategoryList(userProcurementSubCategoryList);          
        },
        function (error: Error) {
          setProcurementSubCategoryList([]);
        }
      ),
    ]).then((values) => {
      compeleteRequest(true);
      setIsUpdateOpen(true);
    });
  };

  const onEditClick = (listItem: User) => {
    setSelectedData(listItem);
    //setIsEditPress(true);
    getMaterDataAdd();
  };

  const onDeleteClick = (listItem: User) => {
    dispatch(
      AllActions.alertDialogActions.openAlertDialog(
        translation.master_delete_con_title,
        translation.master_delete_con_msg,
        translation.master_delete_con_yesbtn,
        function () {
          setSelectedData(listItem);
          prepareForRequest();
          MasterDataService.deleteUser(
            listItem,
            function (responseData: any) {
              setTableRowData(
                tableRowData.map((row: User) => {
                  if (row.id === listItem.id) {
                    return { ...row, ["isActive"]: false };
                  }
                  return row;
                })
              );
              compeleteRequest(true, translation.master_user_dialog_delete_suc);
              dispatch(AllActions.alertDialogActions.closeAlertDialog());
            },
            function (error: Error) {
              compeleteRequest(false, translation.master_user_delete_err);
            }
          );
        },
        translation.master_delete_con_nobtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
        }
      )
    );
  };

  const handleUpdateDialogClose = (e: any) => {
    setIsUpdateOpen(false);
  };

  const handleSuccessUserUpdate = (user: User) => {
    setTableRowData(
      tableRowData.map((row: User) => {
        if (row.id === user.id) {
          return user;
        }
        return row;
      })
    );
  };

  const getUsersList = () => {
    prepareForRequest();
    MasterDataService.getUsersList(
      filterParams,
      function (responeData: UserListRespone) {
        setTableRowData(responeData.adUsers);
        setRowCount(responeData.recordCount);
        compeleteRequest(true);
        setIsTableLoading(false);
      },
      function (error: Error) {
        setTableRowData([]);
        compeleteRequest(false, translation.master_user_list_error);
        setIsTableLoading(false);
      }
    );
  };

  useEffect(() => {
    if (isTableLoading) {
      getUsersList();
    }
  }, [isTableLoading]);

  useEffect(() => {
    setFilterParams((state) => {
      return {
        ...filterParams,
        pageNo: 1,
      };
    });
    setPage(0);
    setIsTableLoading(true);
    VendorMasterData.getCompanyCodes(
      function (sbuList: Array<Company>) {
        setSbuList(sbuList);
      },
      function (error: Error) {
        setSbuList([]);
      }
    );

    MasterMetaDataService.getUserRoles(
      function (userRolesist: Array<UserRole>) {
        setUserRolesList(userRolesist);
      },
      function (error: Error) {
        setUserRolesList([]);
      }
    );
  }, []);

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.createHeader}
      >
        <span className={classes.createHeaderTxt}>
          {translation.main_menu_master_usermangemnet}
        </span>
        {/* <span className={classes.createHeaderLine}></span> */}
      </Grid>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={1}
        lg={1}
        style={{ float: "right" }}
      >
        <div className={classes.addNewBtnWrapper}>
          <Button
            onClick={handleAddTableData}
            style={{ right: "18px", position: "absolute", top: "80px" }}
          >
            <AddCircleIcon></AddCircleIcon>
            {translation.master_table_user_addbtntxt}
          </Button>
        </div>
      </Grid>

      {/* Filter area START */}
      <div>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
          <Grid
            container
            spacing={2}
            item
            xs={12}
            sm={12}
            md={1}
            lg={1}
            className={classes.filterheader}
          >
            Filter
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            <div className={classes.filterWrapper}>
              <div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.master_userfilter_email}
                </label>
                <div className={classes.inputWrapperFilter}>
                  <TextField
                    variant="outlined"
                    onChange={handleChange("emailAddress")}
                  ></TextField>
                </div>
              </div>
              <div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.master_acc_subcat_isactive}
                </label>
                <div className={classes.inputWrapperFilter}>
                  <Switch
                    checked={filterParams!.isActive}
                    onChange={handleChange("isActive")}
                  ></Switch>
                </div>
              </div>
              <div className={classes.dataBlock}>
                <div className={classes.searchBtnWrapper}>
                  <Button onClick={handleFilter} style={{ float: "left" }}>
                    <SearchIcon></SearchIcon>
                    {translation.dashboard_filternm_btntxt}
                  </Button>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        {/* Filter area END */}
        <div className={classes.tblOuterBG}>
          <TableContainer className={classes.tblContainer}>
            <Table size="small" stickyHeader aria-label="sticky table">
              <TableHead className={classes.tblHeader}>
                <TableRow>
                  <TableCell>
                    <Checkbox></Checkbox>
                  </TableCell>
                  {tableColumnData &&
                    tableColumnData.map((column, index) => {
                      return <TableCell>{column.name}</TableCell>;
                    })}
                  <TableCell align="center" style={{ width: "165px" }}>
                    {translation.master_table_actions}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tblBody}>
                {tableRowData &&
                  tableRowData.map((row, index) => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell>
                          <Checkbox></Checkbox>
                        </TableCell>
                        <TableCell>{row.userName}</TableCell>
                        <TableCell>{row.emailAddress}</TableCell>
                        <TableCell>{getDisplaySBU(row)}</TableCell>
                        {/* <TableCell>{getDisplayRoles(row)}</TableCell> */}
                        <TableCell>{getDisplayClusters(row)}</TableCell>
                        <TableCell>
                          <Checkbox
                            checked={row.isActive}
                            disabled={true}
                          ></Checkbox>{" "}
                        </TableCell>
                        <TableCell align="center">
                          <div className={classes.editBtn}>
                            <button onClick={(e) => onEditClick(row)}>
                              <EditIcon></EditIcon>
                              <span className={classes.editBtnTxt}>
                                {translation.master_table_editbtntxt}
                              </span>
                            </button>
                          </div>
                          <div className={classes.rejectBtn}>
                            <button
                              disabled={!row.isActive}
                              onClick={(e) => onDeleteClick(row)}
                            >
                              <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                              <span className={classes.rejectBtnTxt}>
                                {translation.master_table_deletebtntxt}
                              </span>
                            </button>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={rowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
          ></TablePagination>
        </div>
      </div>

      <div>
        <UserAddDialog
          open={isUpdateOpen}
          dataObj={copyUser(selectedData)}
          sbuList={sbuList}
          userRolesList={userRolesList}
          clustersList={clustersList}
          setDataObj={setSelectedData}
          handleClose={handleUpdateDialogClose}
          successUpdate={handleSuccessUserUpdate}
          userRmCategoryList={userRmCategoryList}
          userProcurementCategoryList={userProcurementCategoryList}
          userProcurementSubCategoryList={userProcurementSubCategoryList}
        ></UserAddDialog>
      </div>
    </div>
  );
}
